<div class="toaster radius_md">
  <div class="w-100">
    <div class="toast-details gap-2 align-items-center">
      <div class="toast-badge width-2 height-72 radius_md"></div>
      <epmax-icon class="ph-3" [name]="iconName" [color]="iconColor" [size]="45">
      </epmax-icon>
      <div [class]="options.titleClass + ' flex-1'">
        @if (!title) {
          <epmax-typo [name]="'body2'" [weight]="700">
            {{'Labels.Notification' | translate}}
          </epmax-typo>
        }
        @if (!!title) {
          <epmax-typo [weight]="700" [name]="'body2'">{{ title | translate }}</epmax-typo>
        }
        @if (message && options.enableHtml) {
          <div role="alert" aria-live="polite" class="custom-message"
          [class]="options.messageClass" [innerHTML]="message"></div>
        }
        @if (message && !options.enableHtml) {
          <div role="alert" aria-live="polite" class="custom-message"
            [class]="options.messageClass" [attr.aria-label]="message">
            <epmax-typo [name]="'body2'" [color]="'secondary'" [weight]="500">
              {{message | translate}}
            </epmax-typo>
          </div>
        }
        <div class="actions-container gap-2">
          @for (action of actions; track action; let i = $index) {
            <epmax-button [data-automation-id]="getAutomationId(i)"
              [label]="action.label | translate" [size]="action.size"
              [style]="action.style" (click)="action.event()">
            </epmax-button>
          }
        </div>
      </div>
      <div style="align-self: flex-start">
        <epmax-icon [name]="'close'" color ="muted" [size]="20">
        </epmax-icon>
      </div>
    </div>

  </div>
</div>
